import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "spinner" ]
  originalButtonInnerHTML = null; 

  show() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove("hidden");
    }

    // Busca el botón de submit dentro del elemento del controlador (el formulario)
    const submitButton = this.element.querySelector("button[type='submit']");
    if (submitButton) {
      // Almacena el contenido HTML original del botón si aún no se ha hecho
      if (this.originalButtonInnerHTML === null) {
        this.originalButtonInnerHTML = submitButton.innerHTML;
      }
      submitButton.disabled = true; // Deshabilita el botón

      const svgIcon = submitButton.querySelector("svg") ? submitButton.querySelector("svg").outerHTML : "";
      submitButton.innerHTML = `${svgIcon} Enviando...`;
    }
  }

  hide() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("hidden");
    }

    const submitButton = this.element.querySelector("button[type='submit']");
    if (submitButton) {
      submitButton.disabled = false; 
      
      
      if (this.originalButtonInnerHTML !== null) {
        submitButton.innerHTML = this.originalButtonInnerHTML;
      }

    }
  }
}